<template>
  <zpa-row height="34" style="line-height: 34px;padding-left: 250px;">
    <Breadcrumb>
      <BreadcrumbItem v-for="(item, index) in arr" :key="item" @click.native="goto(item,index)"
                      :style="{cursor: (item.text === '首页' ||
                      (index ===2 && ($route.meta.title === '贷款申请次数'
      || $route.meta.title === '微票融操作企业数'
      || $route.meta.title === '微票融操作笔数'
      || $route.meta.title === '单个产品名单库查询'
      || $route.meta.title === '单个产品名单库管理'
      || $route.meta.title === '授信企业列表'
      || $route.meta.title === '企业贷款详细信息1'
      || $route.meta.title === '银行放款信息（已放款(笔)）'
      || $route.meta.title === '银行放款笔数'))
                      )?'pointer':''}">
        <Icon :type="item.icon" />{{ item.text }}
      </BreadcrumbItem>
      <BreadcrumbItem v-if="$route.meta.title === '贷款申请次数'
      || $route.meta.title === '微票融操作企业数'
      || $route.meta.title === '微票融操作笔数'
      || $route.meta.title === '单个产品名单库查询'
      || $route.meta.title === '单个产品名单库管理'
      || $route.meta.title === '授信企业列表'
      || $route.meta.title === '企业贷款详细信息1'
      || $route.meta.title === '银行放款信息（已放款(笔)）'
      || $route.meta.title === '银行放款笔数'"
      >{{targetName?targetName:$route.meta.title}}</BreadcrumbItem>

    </Breadcrumb>
  </zpa-row>

</template>

<script>
export default {
  name: 'Breadcrumb2',

  data() {
    return {
      data: [],
      arr: [],
      targetName: '',
      homeDashboard: {
        'superadmin': '/dashboard',
        'apply': '/enterprisepage',
        'gr': '/personalpage',
        'info': '/ditwopage',
        'other': '/otherpage',
        'fws': '/serviceprovider',
        'yh': '/YHPage',
        'mang': '/ZFJGPage',
        'dbjg': '/BondCompanyPage',
        'zfcg': '/czcgpage',
        'jjglr': '/cjythreepage',
        'sczj': '/cjythreepage',
        'yjj': '/cjythreepage'
      }

    }
  },

  computed: {

  },

  methods: {
    refresh() {
      location.reload(true)
    },

    changeSite(site, index) {
      if (this.data.length === index) {
        return false
      }

      this.$router.push({
        path: this.$route.path,
        query: {
          site,
          noFolder: true,
        }
      })
    },
    initOrGetArr() {
      this.targetName = this.$route.query.targetName

      let str = localStorage.getItem('breadcrumbList');
      if (str) {
        this.arr = JSON.parse(str)
      } else {
        const temp = {'text': '首页', 'icon': 'ios-home', 'url': this.homeDashboard[this.$store.state.positionStation]}
        this.arr = [temp]
        localStorage.setItem('breadcrumbList', JSON.stringify(this.arr))
      }
    },
    goto(item, index) {
      if (this.$route.meta.title === '贷款申请次数' ||
        this.$route.meta.title === '银行放款笔数' ||
        this.$route.meta.title === '微票融操作笔数' ||
        this.$route.meta.title === '单个产品名单库查询' ||
        this.$route.meta.title === '单个产品名单库管理' ||
        this.$route.meta.title === '授信企业列表' ||
        this.$route.meta.title === '企业贷款详细信息1' ||
        this.$route.meta.title === '银行放款信息（已放款(笔)）' ||
        this.$route.meta.title === '微票融操作企业数'
      ) {
        if (index === 2) {
          this.$router.push({
            path: item.url, // 跳转路由
          });
        } else if (this.arr[0].text === '首页') {
          this.$router.push({
            path: '/blankboard', // 跳转路由
          });
        }
      }
    }
  },

  watch: {
    '$route'(now, old) {
      this.data = []
      if (now.query.site) {
        let site = ''
        const res = now.query.site.split('_')

        res.forEach(v => {
          site += site !== '' ? `_${v}` : v
          this.data.push({
            site,
            name: v,
          })
        })
      }
      this.initOrGetArr()
    }
  },

  created() {
    this.$router.push({
      path: this.$route.path,
    })
    this.$root.$on('changeB')
    this.initOrGetArr()
  },
}
</script>

<style scoped lang="less">
  //.breadcrumb {
  //  background-color: #FFFFFF;
  //  margin: 0 0 8px 10px;
  //  font-size: 16px;
  //  color: #666;
  //  display: flex;
  //  flex-direction: row;
  //
  //  li {
  //    list-style: none;
  //    padding: 0 5px;
  //    border-bottom: 1px solid rgba(0, 0, 0, 0);
  //    position: relative;
  //    &:not(:last-of-type) {
  //      cursor: pointer;
  //    }
  //    &:not(:last-of-type):hover {
  //      border-bottom-color: #4285F4;
  //    }
  //    &.item {
  //      margin-left: 10px;
  //    }
  //  }
  //  b {
  //    position: absolute;
  //    left: -12px;
  //    top: -1px;
  //  }
  //}
</style>
